import { render, staticRenderFns } from "./PAReport.vue?vue&type=template&id=081aa360&scoped=true"
import script from "./PAReport.vue?vue&type=script&lang=js"
export * from "./PAReport.vue?vue&type=script&lang=js"
import style0 from "./PAReport.vue?vue&type=style&index=0&id=081aa360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081aa360",
  null
  
)

export default component.exports